// extracted by mini-css-extract-plugin
export var childrenContainer = "_bj-0";
export var virtualScrollArea = "_bj-1";